export default "__VITE_ASSET__Ck0swTOh__"